import { loginInfo } from '@/api/common'
import router from '@/router/router'
import { userlogIn } from '@/service/authService'
import platformManager from '@/service/PlatformManager'
import useUserStore from '@/store/modules/user'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { removeURLQueryParam } from './urlHelper'

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: true, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

const deleteURLTk = () => {
  const url = new URL(location.href)
  const params = new URLSearchParams(url.search)
  //下面2两个参数是d和pid,是用于数据统计的
  params.delete('tk')

  const newUrl =
    url.origin +
    url.pathname +
    (params.toString() ? '?' + params.toString() : '')
  location.href = newUrl
}

/**
 * @description 路由拦截 beforeEach
 * */
const pushToLogin = (next?: any) => {
  const urlParams = new URLSearchParams(window.location.search)
  const tk = urlParams.get('tk')

  if (tk !== null) {
    loginInfo(tk).then(async (res) => {
      if (res.data !== null) {
        await userlogIn(res.data)
        deleteURLTk()
        next({ name: 'Home' })
      } else {
        pushToLogin()
      }
    })
  } else {
    const userStore = useUserStore()
    const token = userStore?.getToken()
    if (token === null) {
      platformManager.redirectToPlatformLoginLink()
    } else {
      next({ name: 'Home' })
    }
  }
}

const updateLocalLanguageHandle = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const lParam = urlParams.get('l')
  if (lParam) {
    localStorage.setItem('language', lParam)
    removeURLQueryParam('l')
    window.location.reload()
  } else {
    // const local = localStorage.getItem('language')
    // if (local !== 'en') {
    //   localStorage.setItem('language', 'en')
    //   window.location.reload()
    // }
  }
}
router.beforeEach((to, from, next) => {
  updateLocalLanguageHandle()
  NProgress.start()
  // 外链
  const externalLink = !!to.meta.link
  if (externalLink) {
    NProgress.done()
    window.open(to.meta.link as string)
    return
  } else {
    if (to.name === 'login' || to.path.includes('login')) {
      // pushToLogin(next)
      next()
      return
    }
    const urlParams = new URLSearchParams(window.location.search)
    const tk = urlParams.get('tk')
    if (tk !== null) {
      loginInfo(tk).then(async (res) => {
        if (res.data !== null) {
          await userlogIn(res.data)
          deleteURLTk()
          next()
        } else {
          pushToLogin()
        }
      })
      return
    }
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
